import { useState, useEffect } from "react"
import "./Terms.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const Terms = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            {/* <!-- no header, just hero with floating badge --> */}

            <section className="terms-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-file-lines"></i> ASK JEEVES IP · O'HANLON PATENT INNOVATION
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">Terms of Use</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">By accessing or using the platform, you agree to be bound by these terms.</p>
                    </div>
                </div>
            </section>
            {/* <!-- main terms card (like collaboration/team section styling) --> */}
            <div className="content-container">
                <div className="terms-card" data-aos="fade-up">

                    <p
                        style={{
                            fontSize: "1.2rem",
                            borderLeft: "4px solid #54A6E9",
                            paddingLeft: "1.5rem"
                        }}
                    >
                        <i
                            className="fa-regular fa-calendar-circle-check"
                            style={{ color: "#1D3A90" }}
                        ></i>{" "}
                        <strong>Last updated:</strong> March 1, 2026
                    </p>

                    <h2>
                        <i className="fa-regular fa-check-circle"></i> 1. Acceptance of Terms
                    </h2>
                    <p>
                        These Terms of Use ("Terms") govern your access to and use of the Ask
                        Jeeves IP website, AI drafting tools, O'Hanlon-enhanced legal review
                        services, and related content (collectively, the "Services"). If you do
                        not agree, you may not use the Services.
                    </p>

                    <h2>
                        <i className="fa-regular fa-id-card"></i> 2. Eligibility
                    </h2>
                    <p>
                        You must be at least 18 years old and capable of forming a binding
                        contract. By using the Services on behalf of an entity, you represent
                        that you have authority to bind that entity.
                    </p>

                    <h2>
                        <i className="fa-regular fa-user-lock"></i> 3. Accounts and Registration
                    </h2>
                    <p>
                        You are responsible for maintaining the security of your account
                        credentials. You must provide accurate information. Notify us immediately
                        of any unauthorized use. We are not liable for loss from unauthorized
                        access.
                    </p>

                    <h2>
                        <i className="fa-regular fa-bolt"></i> 4. Services Overview
                    </h2>
                    <p>
                        Ask Jeeves IP provides an AI-powered platform to assist with patent
                        drafting and prosecution support. The O'Hanlon-patented algorithms help
                        generate invention summaries, prior search organization, and claim
                        language suggestions. Final legal review is performed by licensed patent
                        attorneys when you engage that option.{" "}
                        <strong>
                            We do not provide legal advice unless explicitly stated in an
                            attorney-client engagement.
                        </strong>
                    </p>

                    <div className="term-emphasis" data-aos="zoom-in">
                        <i className="fa-regular fa-gavel"></i>{" "}
                        <strong>
                            No attorney-client relationship (unless formed separately):
                        </strong>{" "}
                        Use of AI drafting tools does not create an attorney-client relationship.
                        If you request review by an O'Hanlon-affiliated attorney, a separate
                        engagement agreement will be provided. Until then, no legal privilege
                        applies.
                    </div>

                    <h2>
                        <i className="fa-regular fa-credit-card"></i> 5. Fees and Subscriptions
                    </h2>
                    <p>
                        Some features require payment. Fees are posted on our site and may change
                        with notice. Subscriptions auto-renew unless canceled. No refunds for
                        partial periods. You are responsible for all taxes.
                    </p>

                    <h2>
                        <i className="fa-regular fa-pen-to-square"></i> 6. User Content and
                        Inventions
                    </h2>
                    <p>
                        You retain ownership of your invention disclosures and drafts. By
                        submitting content, you grant us a license to host, process, and transmit
                        it to provide the Services and improve our algorithms (in
                        aggregated/anonymized form). You represent that your content does not
                        infringe third-party rights.
                    </p>

                    <h2>
                        <i className="fa-regular fa-hand"></i> 7. Acceptable Use Policy
                    </h2>
                    <p>You agree NOT to:</p>

                    <ul>
                        <li>
                            Use the Services for unlawful purposes or to infringe
                            patents/trademarks.
                        </li>
                        <li>Reverse engineer any O'Hanlon-patented component.</li>
                        <li>Interfere with the integrity or performance of the platform.</li>
                        <li>Attempt to scrape or extract data without authorization.</li>
                        <li>Upload malware or malicious code.</li>
                    </ul>

                    <h2>
                        <i className="fa-regular fa-copyright"></i> 8. Intellectual Property
                        Rights
                    </h2>
                    <p>
                        The Services, including the O'Hanlon framework, algorithms, text,
                        graphics, and software, are owned by Ask Jeeves IP and licensors. All
                        rights reserved. Limited license to use during subscription term. Patents
                        pending.
                    </p>

                    <h2>
                        <i className="fa-regular fa-link"></i> 9. Third-Party Links and Attorneys
                    </h2>
                    <p>
                        We may link to third-party sites or connect you with independent patent
                        practitioners. We do not endorse or control those third parties and are
                        not responsible for their actions.
                    </p>

                    <h2>
                        <i className="fa-regular fa-circle-stop"></i> 10. Termination
                    </h2>
                    <p>
                        We may suspend or terminate your access for violation of these Terms,
                        without prior notice. You may cancel at any time. Provisions that by
                        their nature should survive termination shall survive (IP,
                        indemnification, disclaimers).
                    </p>

                    <h2>
                        <i className="fa-regular fa-triangle-exclamation"></i> 11. Disclaimers and
                        Limitations
                    </h2>
                    <p>
                        <strong>THE SERVICES ARE PROVIDED "AS IS."</strong> WE DISCLAIM ALL
                        WARRANTIES, INCLUDING ACCURACY, RELIABILITY, AND THAT PATENTS WILL BE
                        GRANTED. TO THE MAXIMUM EXTENT PERMITTED, OUR LIABILITY IS LIMITED TO THE
                        AMOUNT YOU PAID US IN THE PAST 12 MONTHS.
                    </p>

                    <h2>
                        <i className="fa-regular fa-shield"></i> 12. Indemnification
                    </h2>
                    <p>
                        You agree to indemnify Ask Jeeves IP from any claims arising out of your
                        use, violation of Terms, or infringement of any right.
                    </p>

                    <h2>
                        <i className="fa-regular fa-scale-balanced"></i> 13. Governing Law and
                        Disputes
                    </h2>
                    <p>
                        Delaware law governs. Exclusive venue in state or federal courts in
                        Delaware. You agree to arbitration for individual disputes, with opt-out
                        right (send notice within 30 days). Class action waiver applies.
                    </p>

                    <h2>
                        <i className="fa-regular fa-pencil"></i> 14. Changes to Terms
                    </h2>
                    <p>
                        We may modify these Terms at any time. Continued use after changes
                        constitutes acceptance. Material changes will be notified via email or
                        site notice.
                    </p>

                    <hr
                        style={{
                            margin: "3rem 0",
                            border: "1px solid #e5ecf5"
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "2rem",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <div>
                            <i
                                className="fa-regular fa-message"
                                style={{ color: "#1D3A90" }}
                            ></i>{" "}
                            Questions: <strong>terms@askjeevesip.tech</strong> – we're here to
                            clarify.
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Terms;